// Import .less entry point
import '../assets/private/stylesheets/store/_store.less';
import './store/styles/style';

/** specific country imports */
import { init as initCountrySpecific} from '@/_override/stores/stores-country.entry';
import '@/_override/stores/stores-country.less';
/** end of specific country imports */

import { init as initStoreList } from './store/store-list/store-list';
import { init as initStorePage } from './store/store-page/storePageModule';
import { init as initAcountStoreModule } from './store/store-page/accountStoreModule';
import { init as initStoreReviews } from './store/store-reviews';

document.addEventListener('DOMContentLoaded', () => {
  // StorePage
  if (cube.$('.store-page')) {
    initStorePage();
    initAcountStoreModule();
  }
  // Store
  if (cube.$id('country-list-wrapper')) {
    initStoreList();
  }

  if (cube.$('.store-reviews-page')) {
    initStoreReviews();
  }

  initCountrySpecific();
});



// WEBPACK FOOTER //
// ./src/stores.route.js